import React from 'react';

function AdminStatsCards({ stats }) {
  const items = [
    { label: 'AZI', val: stats.today, desc: 'Variante generate' },
    { label: 'IERI', val: stats.yesterday, desc: 'Variante generate' },
    { label: '7 ZILE', val: stats.last7Days, desc: 'Ultimele 7 zile' },
    { label: '30 ZILE', val: stats.last30Days, desc: 'Ultimele 30 zile' },
    { label: 'LIFETIME (TOTAL)', val: stats.lifetime, desc: 'De la prima instalare', accent: true }
  ];

  return (
    <div className="stats-metric-grid">
      {items.map((item) => (
        <div className={`metric-box ${item.accent ? 'metric-box--accent' : ''}`} key={item.label}>
          <span>{item.label}</span>
          <strong>{item.val.toLocaleString()}</strong>
          <small>{item.desc}</small>
        </div>
      ))}
    </div>
  );
}

export default AdminStatsCards;